var generic = generic || {};
var site = site || {};

(function ($) {
  site.waitlist = {
    templateContainer: $(),

    initWaitlistSignup: function () {
      var $emailContainerNodes = this.templateContainer;

      if (!$emailContainerNodes.length) {
        return null;
      }

      $emailContainerNodes.each(function () {
        var $waitlistContainerNode = $(this);
        var classShowHide = $waitlistContainerNode.find("input[name='unit_class_reveal']").val();
        var $waitlistFormNode = $waitlistContainerNode.find('form');
        var $waitlistSubmitNode = $waitlistContainerNode.find("input[type='submit']");
        var $waitlistProgressNode = $waitlistContainerNode.find('div.progress');
        var $waitlistSuccessNode = $waitlistContainerNode.find('div.success');
        var $waitlistErrorNode = $waitlistContainerNode.find('div.error');
        var $waitlistInputNode = $waitlistContainerNode.find('input.waitlist-signup');
        var $waitlistSubmissionOption = $waitlistContainerNode.find(
          "input[name='redirect_or_text']"
        );
        var $waitlistRedirectURL = $waitlistContainerNode.find("input[name='redirect']");
        var $waitlistSignupText = $waitlistContainerNode.find('div.waitlist-signup__text');
        var $waitlistSignupFields = $waitlistContainerNode.find('div.waitlist-signup__fields');
        var $emailOptStatusNode = $('#address-info-newsletter');

        $waitlistContainerNode
          .find('.close-button')
          .off('click')
          .on('click', function () {
            $waitlistContainerNode.slideUp(600);
            return false;
          });
        if (classShowHide.length > 0) {
          $('.' + classShowHide).hide();
        }

        $waitlistFormNode
          .not('.email-form-processed')
          .addClass('email-form-processed')
          .off('submit')
          .on('submit', function (submitEvt) {
            var parametersArray = $waitlistFormNode.serializeArray();
            var parametersObject = {};
            $.each(parametersArray, function (index, param) {
              parametersObject[param.name] = param.value;
            });

            submitEvt.preventDefault();
            $waitlistSubmitNode.addClass('hidden');
            $waitlistProgressNode.removeClass('hidden');
            parametersObject.redirect = '';
            parametersObject.redirect_or_text = '';

            generic.jsonrpc.fetch({
              method: 'rpc.form',
              params: [parametersObject],
              onSuccess: function (jsonRpcResponse) {
                if (
                  $waitlistSubmissionOption.val() === 'redirect' &&
                  $waitlistRedirectURL.val().length > 0
                ) {
                  let dest = $waitlistRedirectURL.val();
                  if (/^\/.+$/.test(dest)) {
                    dest = dest.replace(/^(\s|\/)+/, '');
                  }
                  if (/^(?!http|\/).+$/.test(dest)) {
                    dest = Drupal.settings.basePath + dest;
                  }
                  window.location.href = dest;
                  return false;
                } else {
                  $waitlistProgressNode.addClass('hidden');
                  $waitlistSuccessNode.removeClass('hidden');
                  $waitlistErrorNode.addClass('hidden');
                  $waitlistFormNode.addClass('hidden');
                  $emailOptStatusNode.addClass('hidden');
                  $waitlistSignupText.addClass('hidden');
                  $waitlistSignupFields.addClass('hidden');
                  $waitlistContainerNode.addClass('email_success');
                  $('html,body').animate(
                    {
                      scrollTop: $('.success').offset().top - 130
                    },
                    1000
                  );
                  if (classShowHide.length > 0) {
                    $('.' + classShowHide).css('visibility', 'hidden');
                    $('.' + classShowHide).show();
                    $('.slick-slider').slick('setOption', 'refresh', true, true);
                    $('.' + classShowHide).css('visibility', 'visible');
                  }
                  $(document).trigger('Waitlist', 'success');
                  $(document).trigger('waitlist:success', [
                    $waitlistContainerNode.find("input[name='EVENT_ID']")
                  ]);
                }
              },
              onFailure: function (jsonRpcResponse) {
                var errorObjectsArray = jsonRpcResponse.getMessages();
                $waitlistErrorNode.html(errorObjectsArray[0].text).removeClass('hidden');
                $waitlistProgressNode.addClass('hidden');
                if (classShowHide.length > 0) {
                  $('.' + classShowHide).hide();
                }
                $waitlistSubmitNode.removeClass('hidden');
                $waitlistInputNode.addClass('error');
                $waitlistContainerNode.removeClass('email_success');
                $(document).trigger('Waitlist', 'fail');
                $(document).trigger('waitlist:failure', [
                  $waitlistContainerNode.find("input[name='EVENT_ID']")
                ]);
              }
            });
          });
      });
    }
  };

  function populateSelect(target, min, max) {
    var self = this;
    var $selectElement = $('select#' + target, self.templateContainer);
    if (!target) {
      return false;
    } else {
      min = min || 0;
      max = max || min + 100;
      var options = [];
      for (var i = min; i <= max; i++) {
        options.push('<option value="' + i + '">' + i + '</option>');
      }
      $selectElement.append(options.join(''));
    }
  }

  Drupal.behaviors.waitlistSignup = {
    attach: function (context, settings) {
      site.waitlist.templateContainer = $('.waitlist-signup__container', context);
      site.waitlist.initWaitlistSignup();
      populateSelect('form--profile_preferences--field--BIRTH_DAY', 1, 31);
      populateSelect('form--profile_preferences--field--BIRTH_MONTH', 1, 12);
    }
  };
})(jQuery);
